class Answer {
  id = null

  label = ''

  question_id = null

  created_at = null

  updated_at = null

  constructor(options = {}) {
    Object.assign(this, options)
  }

  // let answer = (new Answer).fill({ label: "whatever" });
  fill(options) {
    return Object.assign(this, options)
  }
}

export default Answer
